export const emailRegEx =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const passwordRegex = {
  hasOneSpecialChar: /[^a-zA-Z\d\s]/,
  hasOneUpperCase: /[A-Z]/,
  hasAtLeastOneLetter: /[a-zA-Z]/,
  hasAtLeastOneDigit: /\d/,
};
